import { getWWidth } from "./_helpers.js";

/**** TOGGLE FOOTER PORTLETS ON CLICK ****/
function toggleFooterPortlets() {
  const footerTitles = document.querySelectorAll(
    "#portal-footer-wrapper .portletContent h3",
  );
  footerTitles.forEach((title) => {
    // aggiunge tabindex
    title.setAttribute("tabindex", "0");

    title.addEventListener("click", () => {
      const portlet = title.closest(".portletContent");
      if (portlet) portlet.classList.toggle("open");
    });
  });
}

/**** TOGGLE TILES (interesting-contents-tile, news-related) ****/
function toggleTiles() {
  const tilesIdent = [".interesting-contents-tile", ".news-related"];
  tilesIdent.forEach((ident) => {
    const tiles = document.querySelectorAll(`${ident} .tileTitle`);
    tiles.forEach((tile) => {
      tile.addEventListener("click", () => {
        const parent = tile.closest(ident);
        if (parent) parent.classList.toggle("open");
      });
    });
  });
}

/***** MOVE SOCIAL LINKS *****/
function moveSocialLinks(back = false) {
  if (!back) {
    const headerSocial = document.querySelector(
      "#portal-top #unife-header-social",
    );
    const footerFirstCol = document.querySelector(
      "#unife-footer .unife-footer-columns:first-child",
    );

    if (headerSocial && footerFirstCol) {
      // sposta #unife-header-social prima della prima colonna del footer
      footerFirstCol.parentNode.insertBefore(headerSocial, footerFirstCol);
    }
  } else {
    /****** MOVE SOCIAL LINKS BACK *****/
    const footerSocial = document.querySelector(
      "#unife-footer #unife-header-social",
    );
    const headerMenu = document.querySelector("#unife-header-menu");

    if (footerSocial && headerMenu) {
      // sposta #unife-header-social subito dopo il menu header
      headerMenu.insertAdjacentElement("afterend", footerSocial);
    }
  }
}

/***** MOVE PORTAL TOP *****/
let portalTopPlaceholder = null;

function movePortalTop(back = false) {
  const portalTop = document.querySelector("#portal-top");
  const portalLogo = document.querySelector("#content-header #portal-logo");
  const rightZone = document.querySelector("#header-right-zone");

  if (!portalTop) return;

  // Salva la posizione originale solo la prima volta
  if (!portalTopPlaceholder) {
    portalTopPlaceholder = document.createComment("portal-top-placeholder");
    portalTop.parentNode.insertBefore(portalTopPlaceholder, portalTop);
  }

  if (back) {
    // Riporta #portal-top nella posizione originale
    if (portalTopPlaceholder.parentNode) {
      portalTopPlaceholder.parentNode.insertBefore(
        portalTop,
        portalTopPlaceholder,
      );
    }
  } else {
    // // Sposta #portal-top dopo #portal-logo
    // if (portalLogo && portalLogo.parentNode) {
    //   portalLogo.parentNode.insertBefore(portalTop, portalLogo.nextSibling);
    // }
    //Sposta #portal-top dentro #header-right-zone
    if (rightZone) {
      rightZone.prepend(portalTop);
    }
  }
}

function openNav() {
  if (!document.getElementById("offcanvasNavbar").classList.contains("show")) {
    document.getElementById("offcanvasNavbar").classList.add("show");
  }
}
function closeNav() {
  if (document.getElementById("offcanvasNavbar").classList.contains("show")) {
    document.getElementById("offcanvasNavbar").classList.remove("show");
  }
}

function mobileMenu(breakPoint) {
  const width = getWWidth();

  if (width < breakPoint) {
    // mobile
    //clone unife header menu to mobile menu
    const unifeHeaderMenu = document.querySelector("#unife-header-menu ul");
    const unifeHeaderMenuMobile = document.getElementById(
      "unife-header-menu-mobile",
    );

    if (unifeHeaderMenu && !unifeHeaderMenuMobile) {
      const clonedMenu = unifeHeaderMenu.cloneNode(true); // clone
      clonedMenu.id = "unife-header-menu-mobile";
      document
        .querySelector("#offcanvasNavbar .offcanvas-body")
        .appendChild(clonedMenu);
    }
  } else {
    // desktop
    document.getElementById("unife-header-menu-mobile")?.remove();
    closeNav();
  }
}

export function unifeMobile() {
  const width = getWWidth();
  const breakPoint = 1200;

  mobileMenu(breakPoint);
  if (width <= breakPoint) {
    moveSocialLinks();
    movePortalTop();
    toggleFooterPortlets();
    toggleTiles();
  } else {
    moveSocialLinks(true);
    movePortalTop(true);
  }
}
